export interface NotificationSendRequest {
    title: string;
    body: string;
}

export function NotificationActions() {
    function createNotificationSendRequest(
        title: string,
        body: string
    ): NotificationSendRequest {
        return {
            title: title,
            body: body,
        };
    }

    return {
        createNotificationSendRequest,
    };
}